import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { untranslatedString } from 'models/translated-string';
import { AuthRole } from '@cf-shared/couch-auth';
import { describeAuthRoles } from 'util/formatting';
import { CloudFunctionsService } from 'services/cloud-functions.service';
import { AuthService } from 'services/auth.service';
import { DateTime } from 'luxon';
import { CsPage, NavController } from 'providers/nav-controller';
import { LoadingController } from 'providers/loading-controller';
import { ModalPageMarker } from 'providers/modal-page-marker';
import { AdminKeygenPageParams } from './admin-keygen-interface';

@Component({
    selector: 'page-admin-keygen',
    templateUrl: 'admin-keygen.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ModalPageMarker]
})
export class AdminKeygenPage extends CsPage<AdminKeygenPageParams> {
  // admin page: the role NAME comes through translated, while `adminExplanation` stays English
  // on purpose -- admin pages are the project's standing carve-out from translation.
  protected authRoleDescriptions = describeAuthRoles();
  protected role: AuthRole = null;
  protected key = '';
  protected testKey = false;
  protected validFrom = DateTime.local().toISODate();
  protected validUntil = DateTime.local().plus({ months: 1 }).toISODate();
  public numUses = undefined;

  public AuthRole = AuthRole;

  constructor(
    public navCtrl: NavController,
    protected cloudFunctions: CloudFunctionsService,
    protected auth: AuthService,
    protected loadingCtrl: LoadingController,
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }

  async ionViewCanEnter() {
    return this.auth.pageAuthGuardAsync(AuthRole.Dev);
  }

  roleChanged() {
    console.log(`Chose: ${this.role}`);
  }

  handleGenerateKey() {
    void this.generateKeyAsync();
  }

  async generateKeyAsync() {
    let loading = this.loadingCtrl.create({ content: untranslatedString('Generating') });
    void loading.present();
    let role = parseInt(this.role as any as string);
    let testKey = this.testKey ? true : undefined;
    let validFrom = role === AuthRole.Paid && this.validFrom && DateTime.fromISO(this.validFrom).toUTC().toISODate();
    let validUntil =
      (role === AuthRole.Paid) && this.validUntil && DateTime.fromISO(this.validUntil).toUTC().toISODate();
    let result = await this.cloudFunctions.generateActivationKeyAsync({
      role: role,
      testKey: testKey,
      validFrom_utc: validFrom,
      validUntil_utc: validUntil,
    });
    void loading.dismiss();
    this.key = result.code || result.error;
    this.cdRef.markForCheck();
  }

  reset() {
    this.key = '';
    this.cdRef.markForCheck();
  }
}
